import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProjectParam, SlideData, slideTypeShortcodes } from 'app/models/slideData.model';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectSlidesService {
  private apiUrl = `${environment.baseUrl}/projectSlides`;
  constructor(private http: HttpClient, private commonAPI: CommonApiService) { }


  getSlidesByProject(projectCode: string): Observable<SlideData[]> {
    console.log(`${this.apiUrl}/getProjectSlidesWithProjectCode/${projectCode}`);


    return this.commonAPI.getApiCall(`${this.apiUrl}/getProjectSlidesWithProjectCode/${projectCode}`);
    // return this.http.get<SlideData[]>(`${this.apiUrl}/getProjectSlidesWithProjectCode/${projectCode}`);
  }

  addSlide(projectCode: string, slide: Partial<SlideData>): Observable<SlideData> {
    console.log("Entered add slide in service");
    console.log(projectCode);
    console.log(slide);
    console.log(`${this.apiUrl}/addProjectSlide`);


    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "projectCode": projectCode,
        "slide": slide,
        "tenant": null
      }
    };


    let aaa = this.commonAPI.postApiCall(`${this.apiUrl}/addProjectSlide`, body);
    console.log('addProjectSlide response:', aaa);
    return aaa;

    // return this.http.post<SlideData>(`${this.apiUrl}/addProjectSlide`, { projectCode, slide });
  }

  /** Update an existing slide (uses same backend endpoint as add). */
  saveSlide(projectCode: string, slide: Partial<SlideData>): Observable<any> {
    const body = {
      criteria: {
        projectCode,
        slide,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/addProjectSlide`, body);
  }

  /** Seed slide lines for one slide after choosing slideType. When replaceExisting is true, removes existing lines and slide-related audio files first, then seeds again. */
  seedLinesForOneSlide(projectCode: string, projectSlideId: number, slideType: string, replaceExisting = false): Observable<any> {
    const body = {
      criteria: {
        projectCode,
        projectSlideId,
        slideType,
        replaceExisting,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/seedLinesForOneSlide`, body);
  }

  /** Recompute object-group grid/overlap placement for one slide (after add/reorder groups). */
  finalizeLinesForOneSlide(projectCode: string, projectSlideId: number): Observable<any> {
    const body = {
      criteria: {
        projectCode,
        projectSlideId,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/finalizeLinesForOneSlide`, body);
  }


  getProjectParameters(projectCode: string): Observable<ProjectParam[]> {

    return this.commonAPI.getApiCall(`${this.apiUrl}/getProjectParams/${projectCode}`);
    // return this.http.get<ProjectParam[]>(`${this.apiUrl}/getProjectParams/${projectCode}`);
  }

  getLinkedLesson(projectCode: string): Observable<{ linked: boolean; lessonUserId?: number; lessonId?: number }> {
    return this.commonAPI.getApiCall(`${this.apiUrl}/getLinkedLesson/${projectCode}`);
  }



  getslideTypeSC(projectCode: string): Observable<slideTypeShortcodes[]> {

    return this.commonAPI.getApiCall(`${this.apiUrl}/getslideTypeSCs/${projectCode}`);
    // return this.http.get<slideTypeShortcodes[]>(`${this.apiUrl}/getslideTypeSCs/${projectCode}`);
  }

  // replace the list (useful after reordering or delete)
  updateOrder(projectCode: string, slides: SlideData[]): Observable<any> {
const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "projectCode": projectCode,
        "slides": slides,
        "tenant": null
      }
    };


    let aaa = this.commonAPI.postApiCall(`${this.apiUrl}/reorder`, body);
    console.log('addProjectSlide response:', aaa);
    return aaa;

     // return this.http.post(`${this.apiUrl}/reorder`, { projectCode, slides });
  }

  deleteSlide(projectCode: string, SlideCode: number): Observable<any> {
    //projectCode, SlideCode

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "projectCode": projectCode,
        "SlideCode": SlideCode,
        "tenant": null
      }
    };


    let aaa = this.commonAPI.postApiCall(`${this.apiUrl}/deleteProjectSlide`, body);
    console.log('addProjectSlide response:', aaa);
    return aaa;

 
    // return this.http.post(`${this.apiUrl}/deleteProjectSlide`, { projectCode, SlideCode });
  }

  deleteSlides(projectCode: string, slideIds: number[]): Observable<any> {
    const body = {
      criteria: {
        projectCode,
        slideIds,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/deleteProjectSlides`, body);
  }
  exportForPPT(projectCode: string, slideIds: number[]): Observable<Blob> {
    const body = {
      criteria: {
        projectCode,
        slideIds,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCallForFile(`${this.apiUrl}/exportForPPT`, body);
  }

  dependencyList(projectCode: string, slideIds: number[]): Observable<Blob> {
    const body = {
      criteria: {
        projectCode,
        slideIds,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCallForFile(`${this.apiUrl}/dependencyList`, body);
  }

  checkSlides(projectCode: string, slideIds: number[]): Observable<Blob> {
    const body = {
      criteria: {
        projectCode,
        slideIds,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCallForFile(`${this.apiUrl}/checkSlides`, body);
  }

  /** Step 1: Create projectslides from linked lesson TOC (project_lesson + lessontoc). */
  buildSlidesStep1FromLesson(projectCode: string, replaceExisting = false): Observable<any> {
    const body = {
      criteria: { projectCode, replaceExisting, tenant: null }
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/buildSlidesStep1FromLesson`, body);
  }

  /** Step 2: Seed projectslideline from slide types where lines are missing. */
  buildSlidesStep2SeedLines(projectCode: string): Observable<any> {
    const body = { criteria: { projectCode, tenant: null } };
    return this.commonAPI.postApiCall(`${this.apiUrl}/buildSlidesStep2SeedLines`, body);
  }

  /** Step 3: Map lesson slideJson elements into line PSLValue (TEXT / IMAGE / AUDIO). */
  buildSlidesStep3MapLessonContent(projectCode: string): Observable<any> {
    const body = { criteria: { projectCode, tenant: null } };
    return this.commonAPI.postApiCall(`${this.apiUrl}/buildSlidesStep3MapLessonContent`, body);
  }

  /** Copy lesson image files into the project for one slide (aligned with lesson slideJson IMAGE elements). */
  pickLessonImagesForSlide(projectCode: string, projectSlideId: number): Observable<any> {
    const body = { criteria: { projectCode, projectSlideId, tenant: null } };
    return this.commonAPI.postApiCall(`${this.apiUrl}/pickLessonImagesForSlide`, body);
  }

  /** Upload a project-level common asset (images/audio) for packaging. */
  uploadProjectAsset(projectCode: string, assetType: 'IMAGE' | 'AUDIO', fileName: string, fileBase64: string): Observable<any> {
    const body = { criteria: { projectCode, assetType, fileName, fileBase64, tenant: null } };
    return this.commonAPI.postApiCall(`${this.apiUrl}/uploadProjectAsset`, body);
  }

  /** Extract a ZIP under projects/{code}/ (paths as in the ZIP). Pass overwrite after conflict confirm. */
  uploadProjectAssetsZip(
    projectCode: string,
    fileName: string,
    fileBase64: string,
    overwrite = false,
  ): Observable<any> {
    const body = {
      criteria: {
        projectCode,
        fileName,
        fileBase64,
        overwrite: overwrite === true,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/uploadProjectAssetsZip`, body);
  }

  /** Build and save the transfer/assessment workbooks under the project's transfer folder. */
  createTransferFiles(projectCode: string, exportLanguageShortCode = ''): Observable<any> {
    const body = {
      criteria: {
        projectCode,
        exportLanguageShortCode: exportLanguageShortCode || '',
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/createTransferFiles`, body);
  }

  /** ZIP the existing transfer workbook and project assets, then stream it for download. */
  downloadTransferPackage(projectCode: string): Observable<Blob> {
    const body = { criteria: { projectCode, tenant: null } };
    return this.commonAPI.postApiCallForFile(`${this.apiUrl}/downloadTransferPackage`, body);
  }
}
